const getHeight = (domEl) => {
  if (domEl) {
    return domEl.clientHeight || domEl.offsetHeight;
  }

  return null;
};

export default getHeight;
